import React, { useState, useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SearchProvider } from "../../../../../../../search/src/Context/SearchProvider";
import { SearchContext } from "../../../../../../../search/src/Context/SearchContext";
import {URL_SEARCH} from "../../../../../Components/Routes/Location";
import "./SearchBar.css";
import {
  TEXT_SPLIT_LENGTH,
  DEFAULT_SEARCH_LIMIT,
  DEFAULT_SEARCH_PAGE,
  DEFAULT_SEARCH_SORTING,
  SEARCH_MIN_CHARS,
} from "./SearchBarConstants";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { useSelector, useDispatch } from "react-redux";
import {
  saveSearchTextActionCreator,
  turnOffLoadingActionCreator,
  turnOnLoadingActionCreator
} from "../../../../../actions/commonActions";
import { getSearchContentsService } from "../../../../../services/services";

const SearchBar = (props) => {
  const { cancel, focus } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const { updateText } = useContext(SearchContext);
  const { updateWidgets } = useContext(SearchContext);

  const passwordMode = useSelector((state) => state.commonState.passwordMode);

  let error = false;

  const [text, setText] = useState("");
  const [widgets, setWidgets] = useState([]);
  const latestRequestTimestamp = useRef(0);

  const searchContext = useContext(SearchContext);

  useEffect(() => {
    setText(searchContext.text ? searchContext.text : "");
  }, [searchContext.text]);

  const getSearchContentCallback = (response, requestTimestamp) => {
    // Solo procesar si es la petición más reciente
    if (requestTimestamp === latestRequestTimestamp.current) {
      const widgets = response?.data;
      setWidgets(widgets);
      dispatch(turnOffLoadingActionCreator());
      if (updateWidgets) {
        updateWidgets(widgets);
      }
    }
  };

  const searchControllerRef = useRef(null);

  const filter = (event) => {
    const value = event?.target?.value;
    if (value !== undefined) {
      setText(value);
      dispatch(saveSearchTextActionCreator(value));

      if (updateText) {
        updateText(value);
      }

      if (value.length > SEARCH_MIN_CHARS) {
        // Cancelar la petición anterior si existe
        if (searchControllerRef.current) {
          searchControllerRef.current.abort();
        }

        // Crear un nuevo controlador para esta petición
        const controller = new AbortController();
        searchControllerRef.current = controller;

        const requestTimestamp = Date.now();
          latestRequestTimestamp.current = requestTimestamp;

        dispatch(turnOnLoadingActionCreator());
        getSearchContentsService(
          DEFAULT_SEARCH_SORTING,
          DEFAULT_SEARCH_PAGE,
          DEFAULT_SEARCH_LIMIT,
          value,
            (response) => {
              // Solo procesar si la petición no fue cancelada
              if (!controller.signal.aborted) {
                getSearchContentCallback(response, requestTimestamp);
              }
            },
            controller.signal // Pasar la señal al servicio
        );
      }

      if (value.length >= TEXT_SPLIT_LENGTH) {
        history.push(URL_SEARCH);
      }
    }
  };

  const ariaProps = {
    inputProps: {
      "aria-label": t("global.button.go.to.player"),
    },
  };

  const handleInputChange = (data) => {
    if (data.length > SEARCH_MIN_CHARS) {
      // Cancelar la petición anterior si existe
      if (searchControllerRef.current) {
        searchControllerRef.current.abort();
      }

      // Crear un nuevo controlador para esta petición
      const controller = new AbortController();
      searchControllerRef.current = controller;

      const requestTimestamp = Date.now();
      latestRequestTimestamp.current = requestTimestamp;

      dispatch(turnOnLoadingActionCreator());
      getSearchContentsService(
        DEFAULT_SEARCH_SORTING,
        DEFAULT_SEARCH_PAGE,
        DEFAULT_SEARCH_LIMIT,
        data,
          (response) => {
            // Solo procesar si la petición no fue cancelada
            if (!controller.signal.aborted) {
              getSearchContentCallback(response, requestTimestamp);
            }
          },
          controller.signal // Pasar la señal al servicio
      );
    }

    setText(data);

    if (updateText) {
      updateText(data);
    }

    if (data.length >= TEXT_SPLIT_LENGTH) {
      history.push(URL_SEARCH);
    }
  };

  return (
    <div className={"Barra-Busqueda"}>
      <Autocomplete
          disablePortal
          id="suggestions-autocomplete"
          options={[]}
          sx={{ width: 300 }}
          closeIcon={false}
          popupIcon={false}
          freeSolo
          disabled={passwordMode}
          noOptionsText={t("search.results.text")}
          onInputChange={(ev, text) => handleInputChange(text)}
          renderInput={(params) => (
              <div className={"SearchContainer"}>
                <div className={"IconSearch"}>
                  <ion-icon name="search-outline" />
                </div>
                <TextField
                    id="searchBarTextField"
                    className="InputNome"
                    value={text}
                    inputRef={(input) => {
                      if (input) {
                        if (focus) {
                          input.focus();
                        } else {
                          input.blur();
                        }
                      }
                    }}
                    onKeyDown={cancel}
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      'aria-label': t("global.button.go.to.player")
                    }}
                    placeholder={t("search.placeholder")}
                    onChange={(event) => filter(event)}
                    {...ariaProps}
                />
              </div>
          )}
      />

      <SearchProvider arrayResult={widgets} text={text} error={error} />
    </div>
  );
};

export default SearchBar;
